import { Container } from '@mui/material'
import React from 'react'
import ServiceList from './ServiceList'
import lightTheme from '../theme'

export default function ServiceListView() {
  return (
    <Container id='services' maxWidth={false} sx={{padding:"20px 0px", backgroundColor:lightTheme.palette.complementary.main}}>
      <ServiceList/>
    </Container>
  )
}
